import { render, staticRenderFns } from "./AdminCreateWork.vue?vue&type=template&id=416b3c6e&scoped=true"
import script from "./AdminCreateWork.vue?vue&type=script&lang=js"
export * from "./AdminCreateWork.vue?vue&type=script&lang=js"
import style0 from "./AdminCreateWork.vue?vue&type=style&index=0&id=416b3c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416b3c6e",
  null
  
)

export default component.exports